import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import { getInitials } from 'utilities/getInitials';
import { PeopleGroupProps } from './PeopleGroup.props';
import {
  peopleGroupBoxSx,
  peopleTooltipContentSx,
  personAvatarDimensionsSx,
  personAvatarWrapperSx,
  personExtraCountBadgeSx,
  tooltipArrowSx,
  tooltipSx,
} from './PeopleGroup.styles';
import { getCalendarPersonDisplayName } from './PeopleGroup.utilities';

const PeopleGroup = ({ people, roleLabel, avatarBg, avatarInitialsColor }: PeopleGroupProps) => {
  if (people.length === 0) {
    return null;
  }

  const firstPerson = people[0];
  const extraCount = people.length - 1;
  const firstPersonName = getCalendarPersonDisplayName(firstPerson);

  return (
    <Tooltip
      arrow
      placement="top"
      slotProps={{
        tooltip: { sx: tooltipSx },
        arrow: { sx: tooltipArrowSx },
      }}
      title={
        <Box sx={peopleTooltipContentSx}>
          <Typography variant="caption" fontWeight="bold">
            {roleLabel}
          </Typography>
          {people.map(person => (
            <Typography key={person.id} variant="caption" display="block">
              {getCalendarPersonDisplayName(person)}
            </Typography>
          ))}
        </Box>
      }>
      <Box
        sx={peopleGroupBoxSx}
        aria-label={
          extraCount > 0
            ? `${roleLabel}: ${firstPersonName}, +${extraCount} more`
            : `${roleLabel}: ${firstPersonName}`
        }>
        <Box sx={personAvatarWrapperSx}>
          <Avatar
            src={firstPerson.picture_url ?? undefined}
            sx={{ ...personAvatarDimensionsSx, color: avatarInitialsColor }}
            style={{ backgroundColor: avatarBg }}>
            {getInitials({ name: firstPersonName })}
          </Avatar>
          {extraCount > 0 && <Box sx={personExtraCountBadgeSx}>+{extraCount}</Box>}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default PeopleGroup;
